module.exports = __webpack_public_path__ + "img/jingzhuang1.579fba27.jpg";